import { FSFetchReasons, FSFetchStatus, FSSdkStatus, useFlagship } from "@flagship.io/react-sdk";
import env from "app/utils/env";

/**
 * Vrai quand l'affectation du visiteur aux campagnes est connue ou ne le sera jamais : les flags
 * lus ensuite sont définitifs. Sans clés le SDK ne démarre pas, et une API en échec (timeout SDK
 * de 2 s) se termine en FLAGS_FETCHING_ERROR : ces deux cas ne doivent pas bloquer la page.
 */
export const useIsFlagshipDecisionSettled = () => {
	const { sdkStatus, flagsStatus } = useFlagship();

	const isFlagshipConfigured = Boolean(env("FLAGSHIP_ENV_ID") && env("FLAGSHIP_APP_KEY"));
	const isFlagshipInPanic =
		sdkStatus === FSSdkStatus.SDK_PANIC || flagsStatus?.status === FSFetchStatus.PANIC;
	const areFlagsFetched = flagsStatus?.status === FSFetchStatus.FETCHED;
	const hasFlagsFetchFailed = flagsStatus?.reason === FSFetchReasons.FLAGS_FETCHING_ERROR;

	return !isFlagshipConfigured || isFlagshipInPanic || areFlagsFetched || hasFlagsFetchFailed;
};
